import { flashcards, quizzes, summaries } from '../../../DataAccessLayer/services';
import { RESOURCE_LABEL } from '../../common/constants';

/*
 * The kinds of study resource the dashboard knows about. One list drives the
 * Generate a Resource menu, the desktop and the phone tabs, so they
 * cannot drift apart.
 *
 */
export const RESOURCE_TYPES = [
  {
    id: 'flashcards',
    label: RESOURCE_LABEL.FLASHCARD_DECK,
    pluralLabel: 'Flashcard Decks',
    lowercasePlural: 'flashcard decks',
    route: 'flashcards',
    service: flashcards,
    hasEditor: true,
  },
  {
    id: 'quiz',
    // Singular: menu entries, table headings, dialogs and toasts.
    label: RESOURCE_LABEL.QUIZ,
    // Plural: phone tabs and "no results" messages.
    pluralLabel: 'Practice Quizzes',
    lowercasePlural: 'practice quizzes',
    route: 'quiz',
    service: quizzes,
    hasEditor: true,
  },
  {
    id: 'summary',
    label: RESOURCE_LABEL.SUMMARY_NOTES,
    pluralLabel: 'Summary Notes',
    lowercasePlural: 'summary notes',
    route: 'summary',
    service: summaries,
    hasEditor: true,
  },
];
